import { render, staticRenderFns } from "./CommonSteps.vue?vue&type=template&id=03898272"
import script from "./CommonSteps.vue?vue&type=script&lang=js"
export * from "./CommonSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports